import React, { useEffect } from "react";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";

const Participants = ({
  data,
  Winnertype = null,
  prize = null,
  team = null,
}) => {
  // console.log(team);
  const axiosPrivate = useAxiosPrivate();
  useEffect(() => {}, []);
  return (
    <div>
      <div className="flex flex-col p-3 border border-gray-700 bg-black bg-opacity-60 rounded-xl py-1 px-1 w-full text-center sm:text-left">
        <p
          className={`text-center text-sm font-bold ${
            team == "duo1"
              ? "text-yellow-500"
              : team == "duo2"
              ? "text-blue-500"
              : team == "duo3"
              ? "text-orange-400"
              : team == "squad1"
              ? "text-yellow-500"
              : team == "squad2"
              ? "text-blue-500"
              : Winnertype == "firstWinner"
              ? "text-yellow-500"
              : Winnertype == "seccondWinner"
              ? "text-blue-500"
              : Winnertype == "thirdWinner"
              ? "text-orange-500"
              : ""
          }`}
        >
          {team == "duo1"
            ? "Team Duo 1"
            : team == "duo2"
            ? "Team Duo 2"
            : team == "duo3"
            ? "Team Duo 3"
            : team == "squad1"
            ? "Team Squad 1"
            : team == "squad2"
            ? "Team Squad 2"
            : Winnertype == "firstWinner"
            ? "1st Winner"
            : Winnertype == "seccondWinner"
            ? "2nd Winner"
            : Winnertype == "thirdWinner"
            ? "3rd Winner"
            : ""}
        </p>
        <p
          className={`text-center text-lg font-bold ${
            team == "duo1"
              ? "text-yellow-500"
              : team == "duo2"
              ? "text-blue-500"
              : team == "duo3"
              ? "text-orange-400"
              : team == "squad1"
              ? "text-yellow-500"
              : team == "squad2"
              ? "text-blue-500"
              : Winnertype == "firstWinner"
              ? "text-yellow-500"
              : Winnertype == "seccondWinner"
              ? "text-blue-500"
              : Winnertype == "thirdWinner"
              ? "text-orange-400"
              : ""
          }`}
        >
          {team == "duo1"
            ? "1st Place"
            : team == "duo2"
            ? "2nd Place"
            : team == "duo3"
            ? "3rd place"
            : team == "squad1"
            ? "1st Place"
            : team == "squad2"
            ? "2nd Place"
            : Winnertype == "firstWinner"
            ? "1st Place"
            : Winnertype == "seccondWinner"
            ? "2nd Place"
            : Winnertype == "thirdWinner"
            ? "3rd place"
            : ""}
        </p>
        <p className="text-center">Participant </p>
        <div className="flex-shrink-0  m-2 w-32 h-32 rounded-full  self-center">
          <img src={data?.profilePicture} className=" w-32 h-32 rounded-full" />
        </div>
        <div className="flex flex-col  text-center p-2">
          <h4 className="text-xs font-light text-ellipsis ">
            {data?.pubgName}
          </h4>
        </div>
        <p className="text-center font-bold text-lg">
          {prize ? prize + " " + "PKR" : ""}
        </p>
      </div>
    </div>
  );
};

export default Participants;
